/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExportStatusDTO
 */
export interface ExportStatusDTO {
    /**
     * 
     * @type {string}
     * @memberof ExportStatusDTO
     */
    personId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportStatusDTO
     */
    exportType?: ExportStatusDTOExportTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ExportStatusDTO
     */
    dateTime?: Date;
}

/**
* @export
* @enum {string}
*/
export enum ExportStatusDTOExportTypeEnum {
    Card = 'CARD',
    Overcharged = 'OVERCHARGED'
}

export function ExportStatusDTOFromJSON(json: any): ExportStatusDTO {
    return ExportStatusDTOFromJSONTyped(json, false);
}

export function ExportStatusDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportStatusDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'personId': !exists(json, 'personId') ? undefined : json['personId'],
        'exportType': !exists(json, 'exportType') ? undefined : json['exportType'],
        'dateTime': !exists(json, 'dateTime') ? undefined : (new Date(json['dateTime'])),
    };
}

export function ExportStatusDTOToJSON(value?: ExportStatusDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'personId': value.personId,
        'exportType': value.exportType,
        'dateTime': value.dateTime === undefined ? undefined : (value.dateTime.toISOString()),
    };
}

